"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var TabContext_1 = __importDefault(require("./TabContext"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return (props.hidden ? 'display: none;' : ''); });
var TabPanel = function (_a) {
    var children = _a.children, className = _a.className, tabGroup = _a.tabGroup;
    var _b = (0, react_1.useContext)(TabContext_1.default), activeTab = _b.activeTab, idPrefix = _b.idPrefix;
    var selected = activeTab === tabGroup;
    return ((0, jsx_runtime_1.jsx)(Container, __assign({ className: className, role: "tabpanel", id: "".concat(idPrefix, "-").concat(tabGroup, "-panel"), "aria-labelledby": "".concat(idPrefix, "-").concat(tabGroup, "-tab"), hidden: !selected }, { children: children })));
};
exports.default = TabPanel;
var templateObject_1;
